export const GET_ACCOUNT_OPERATIONS = "GET_ACCOUNT_OPERATIONS";
export const GOT_ACCOUNT_OPERATIONS = "GOT_ACCOUNT_OPERATIONS";
export const GOT_ACCOUNT_OPERATIONS_ERROR = "GOT_ACCOUNT_OPERATIONS_ERROR";

export const GET_OPERATION = "GET_OPERATION";
export const GOT_OPERATION = "GOT_OPERATION";
export const GOT_OPERATION_ERROR = "GOT_OPERATION_ERROR";
